<ng-template #loading>
  <div class="d-flex justify-content-center">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>

<h2 class="mt-2">
  <strong>{{ quizTitle }} Quiz</strong>
</h2>
<hr />

<!-- <header class="d-flex justify-content-center heading-title">
  <h1 style="color: azure" class="display-4 font-weight-bold">
    {{ quizTitle }} Quiz
  </h1>
</header> -->

<ng-container *ngIf="blogPost$ | async as blogPost; else loading">
  <ng-container *ngIf="blogPost?.length > 0; else noData">
    <div
      style="display: inline-block"
      class="mb-2"
      *ngFor="let post of blogPost | paginate: config"
    >
      <mat-card class="mat-elevation-z2 mb-3">
        <!-- <mat-card-content>
          <a [routerLink]="['/blog/', post.postId, post.title | slug]">
            <div class="view overlay hm-white-slight">
              <a>
                <div
                  class="mask waves-effect waves-light"
                  mdbRippleRadius
                ></div>
              </a>
            </div>
          </a>
        </mat-card-content> -->
        <mat-card-content>
          <a
            class="blog-title"
            [routerLink]="['/blog/', post.postId, post.quiz, post.title | slug]"
          >
            <h5>{{ post.title }}</h5>
          </a>
        </mat-card-content>
        <mat-card-content>
          <div
            class="text-align-para"
            [innerHTML]="post.content | excerpt"
          ></div>
        </mat-card-content>
        <mat-divider></mat-divider>
        <mat-card-actions align="end">
          <ng-container *ngIf="(appUser$ | async)?.isAdmin">
            <!-- <button
              mat-button
              color="accent"
              [routerLink]="['/editpost', post.postId]"
            >
              Edit
            </button> -->
            <button
              mat-button
              color="accent"
              [routerLink]="['/editpost', post.postId, post.quiz]"
            >
              <i class="fa fa-edit" aria-hidden="true"></i>
            </button>
            <!-- <button
              mat-raised-button
              color="warn"
              (click)="delete(post.postId)"
            >
              Edit
            </button> -->
            <button mat-button color="warn" (click)="delete(post.postId)">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
            <!-- <button
              mat-raised-button
              color="warn"
              (click)="delete(post.postId)"
            >
              Delete
            </button> -->
          </ng-container>
          <span class="spacer"></span>

          <button
            mat-raised-button
            class="app-theme"
            [routerLink]="['/blog/', post.postId, post.quiz, post.title | slug]"
          >
            Read More
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div>
      <mat-divider></mat-divider>
      <app-paginator
        [pageSizeOptions]="pageSizeOptions"
        [config]="config"
      ></app-paginator>
    </div>
  </ng-container>
  <ng-template #noData>
    <h3>No data found</h3>
  </ng-template>
</ng-container>
